<template>
  <div class="animated fadeIn">
    <b-row
      align-h="center"
      class="text-left"
    >
      <b-col md="12">
        <h4>
          {{ 'OMC 수여 기록' }}
        </h4>
      </b-col>
    </b-row>
    <b-row no-gutters="">
      <b-col
        v-for="(record, idx) in pastRecords"
        :key="idx"
        md="2"
      >
        <table>
          <th>{{ record.year }}</th>
          <tr>{{ record.type }}</tr>
          <tr>{{ record.amount }}</tr>
        </table>
      </b-col>
      <b-col
        v-if="pastRecords.length === 0"
        md="12"
        class="text-left"
      >
        ------------------- 없음 -------------------
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <hr>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import api from '../../api'

export default {
  name: 'RemnantPastOmc',
  props: {
    email: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      pastRecords: []
    }
  },
  mounted () {
    if (this.email !== '') {
      this.getDetailInfo(1)
    }
  },
  methods: {
    parseDetailInfo (data) {
      this.pastRecords = []
      data.docs.forEach(doc => {
        this.pastRecords.push(doc)
      })
    },
    getDetailInfo (info) {
      api.request('get', '/admin/omc/past?' + 'email=' + this.email + '&cnt=6')
        .then(response => {
          var data = response.data
          if (data.error) {
            return
          }
          this.parseDetailInfo(data)
        })
    }
  }
}
</script>

<style>
</style>
